import React from 'react';
import { IconProps } from './types';

const ImageUploadPlaceholder: React.FC<IconProps> = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      width="60"
      height="52"
      viewBox="0 0 60 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_12577_46564)">
        <rect x="20" y="8" width="36" height="36" rx="4" fill="white" />
      </g>
      <path
        d="M28.3568 37.5647C27.8425 37.5647 27.3925 37.3719 27.0068 36.9862C26.6211 36.6004 26.4282 36.1504 26.4282 35.6362V16.3504C26.4282 15.8362 26.6211 15.3862 27.0068 15.0004C27.3925 14.6147 27.8425 14.4219 28.3568 14.4219H47.6425C48.1568 14.4219 48.6068 14.6147 48.9925 15.0004C49.3782 15.3862 49.5711 15.8362 49.5711 16.3504V35.6362C49.5711 36.1504 49.3782 36.6004 48.9925 36.9862C48.6068 37.3719 48.1568 37.5647 47.6425 37.5647H28.3568ZM28.3568 35.6362H47.6425V16.3504H28.3568V35.6362ZM30.1568 32.5183H45.8747L41.1497 26.2183L36.9068 31.7147L33.9175 27.6326L30.1568 32.5183Z"
        fill="#CCE4FF"
      />
      <g filter="url(#filter1_d_12577_46564)">
        <rect x="4" width="36" height="36" rx="4" fill="white" />
      </g>
      <path
        d="M12.3568 29.5647C11.8425 29.5647 11.3925 29.3719 11.0068 28.9862C10.6211 28.6004 10.4282 28.1504 10.4282 27.6362V8.35045C10.4282 7.83616 10.6211 7.38616 11.0068 7.00045C11.3925 6.61473 11.8425 6.42188 12.3568 6.42188H31.6425C32.1568 6.42188 32.6068 6.61473 32.9925 7.00045C33.3782 7.38616 33.5711 7.83616 33.5711 8.35045V27.6362C33.5711 28.1504 33.3782 28.6004 32.9925 28.9862C32.6068 29.3719 32.1568 29.5647 31.6425 29.5647H12.3568ZM12.3568 27.6362H31.6425V8.35045H12.3568V27.6362ZM14.1568 24.5183H29.8747L25.1497 18.2183L20.9068 23.7147L17.9175 19.6326L14.1568 24.5183Z"
        fill="#0276FE"
      />
      <defs>
        <filter
          id="filter0_d_12577_46564"
          x="16"
          y="8"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7875 0 0 0 0 0.7875 0 0 0 0 0.7875 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12577_46564" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12577_46564"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_12577_46564"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7875 0 0 0 0 0.7875 0 0 0 0 0.7875 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12577_46564" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12577_46564"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ImageUploadPlaceholder;
